module.exports = __webpack_public_path__ + "static/media/AGirlPic.92761219.svg";